import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';
import * as moment from "moment/moment";

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        bookingId: Number,
        // paymentId: Number,
        modalType: String,
    };

    static targets = [
        "dateInput",
        "startInput",
        "endInput",
        "bookingAlert"
    ];

    connect() {
        this.setupDatePicker();
        this.setupTimePicker();
        this.setupChangeListeners();
    }

    setupDatePicker() {
        const datepickerFields = [this.dateInputTarget];
        datepickerFields.forEach((element) => {
            const options = {
                startDate: moment(),
                minDate: moment(),
                cancelClass: "btn-light",
                applyButtonClasses: "btn-success",
                singleDatePicker: true,
                locale: {
                    firstDay: 1,
                    format: "DD/MM/YYYY",
                    applyLabel: translations["date_picker.apply_label"],
                    cancelLabel: translations["date_picker.cancel_label"],
                    daysOfWeek: [
                        translations["date_picker.days_of_week.sunday"],
                        translations["date_picker.days_of_week.monday"],
                        translations["date_picker.days_of_week.tuesday"],
                        translations["date_picker.days_of_week.wednesday"],
                        translations["date_picker.days_of_week.thursday"],
                        translations["date_picker.days_of_week.friday"],
                        translations["date_picker.days_of_week.saturday"],
                    ],
                    monthNames: [
                        translations["date_picker.month_names.january"],
                        translations["date_picker.month_names.february"],
                        translations["date_picker.month_names.march"],
                        translations["date_picker.month_names.april"],
                        translations["date_picker.month_names.may"],
                        translations["date_picker.month_names.june"],
                        translations["date_picker.month_names.july"],
                        translations["date_picker.month_names.august"],
                        translations["date_picker.month_names.september"],
                        translations["date_picker.month_names.october"],
                        translations["date_picker.month_names.november"],
                        translations["date_picker.month_names.december"],
                    ],
                },
                ...element.dataset, // merge in any data attributes set on the element
            };

            $(element).daterangepicker(options);
        });
    }

    setupTimePicker() {
        let defaultTimepickerHour = moment().hour() + 1;
        const timepickerFields = [this.startInputTarget, this.endInputTarget];
        timepickerFields.forEach((element) => {
            const options = {
                defaultTime: `${defaultTimepickerHour}:00`,
                showSeconds: true,
                icons: {
                    up: "mdi mdi-chevron-up",
                    down: "mdi mdi-chevron-down",
                },
                ...element.dataset, // merge in any data attributes set on the element
            };

            $(element).timepicker(options);
            defaultTimepickerHour++;
        });
    }

    setupChangeListeners() {
        $(this.dateInputTarget).on('change', this.handleFieldChange.bind(this));
        $(this.startInputTarget).on('change', this.handleFieldChange.bind(this));
        $(this.endInputTarget).on('change', this.handleFieldChange.bind(this));
    }

    handleFieldChange() {
        const date = this.dateInputTarget.value;
        const start = this.startInputTarget.value;
        const end = this.endInputTarget.value;
        const modalType = this.modalTypeValue;
        let periodTimeout = this.element.dataset.periodTimeout;

        if (
            window[modalType + "-booking-date-input"] === date &&
            window[modalType + "-booking-start-input"] === start &&
            window[modalType + "-booking-end-input"] === end
        ) {
            return;
        }

        window[modalType + "-booking-date-input"] = date;
        window[modalType + "-booking-start-input"] = start;
        window[modalType + "-booking-end-input"] = end;

        if (periodTimeout) {
            clearTimeout(periodTimeout);
        }

        periodTimeout = setTimeout(() => {
            const data = {
                booking_id: this.bookingIdValue !== 0 ? this.bookingIdValue : null,
                date: moment(date, "DD/MM/YYYY").format("YYYY-MM-DD"),
                start: moment(start, "hh:ss").format("HH:ss"),
                end: moment(end, "hh:ss").format("HH:ss"),
            };

            $.get(routes["app_booking_isslotfree"], data, (result) => {
                if (result.status) {
                    const isSlotFree = result.is_slot_free;

                    if (!isSlotFree && !this.bookingAlertTarget.classList.contains("btn-danger")) {
                        $(this.bookingAlertTarget)
                            .addClass("text-warning")
                            .removeClass("text-danger")
                            .text(translations["manage_booking.The selected date is already busy. You can still continue but check you agenda!"])
                    } else {
                        $(this.bookingAlertTarget).text('').css('display', 'none')
                    }
                } else {
                    $(this.bookingAlertTarget)
                        .addClass("text-danger")
                        .removeClass("text-warning")
                        .text(result.message)
                        .css('display', 'block')
                }
            });
        }, 800);

        this.element.dataset.periodTimeout = periodTimeout;
    }

}
